import React from 'react';

const BR_PATTERN = /<br\s*\/?>/i;

/**
 * 표 칸 안 줄바꿈 `<br>` 을 실제 줄바꿈으로 바꾼다.
 * 칸에 굵게·따옴표·원문 HTML 이 섞이면 children 이 배열로 오므로 문자열 조각마다 나눈다.
 */
export const renderCellBreaks = (children) => {
  const parts = React.Children.toArray(children);
  if (!parts.some((part) => typeof part === 'string' && BR_PATTERN.test(part))) return children;
  return parts.flatMap((part, partIndex) => {
    if (typeof part !== 'string') return [part];
    return part.split(new RegExp(BR_PATTERN.source, 'gi')).flatMap((text, index) => (
      index === 0 ? [text] : [<br key={`br-${partIndex}-${index}`} />, text]
    ));
  });
};

// 한글 파일 칸 합치기 표시(`<<` 왼쪽, `^^` 위). 채팅·복사에서는 빈칸으로 보인다.
const MERGE_MARKERS = new Set(['<<', '^^']);

export const isMergeMarkerText = (value) => MERGE_MARKERS.has(String(value ?? '').trim());

export const isMergeMarkerCell = (children) => {
  const parts = React.Children.toArray(children);
  return parts.length > 0 && parts.every((part) => typeof part === 'string') && isMergeMarkerText(parts.join(''));
};
